module.exports = __webpack_public_path__ + "img/grady.d004f026.jpg";